/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Product } from '../models/product';
@Injectable({
  providedIn: 'root',
})
class ProductService extends __BaseService {
  static readonly ProductGetAllProductsPath = '/api/Product/GetAllProducts';
  static readonly ProductGetProductByIdPath = '/api/Product/GetProductById';
  static readonly ProductCreateProductPath = '/api/Product/CreateProduct';
  static readonly ProductUpdatePath = '/api/Product/UpdateProduct';
  static readonly ProductDeleteProductByIdPath = '/api/Product/DeleteProductById';
  static readonly ProductGetAllDeletedProductsPath = '/api/Product/GetAllDeletedProducts';
  static readonly ProductRestoreDeletedProductByIDPath = '/api/Product/RestoreDeletedProductByID';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  ProductGetAllProductsResponse(): __Observable<__StrictHttpResponse<Array<Product>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Product/GetAllProducts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Product>>;
      })
    );
  }  ProductGetAllProducts(): __Observable<Array<Product>> {
    return this.ProductGetAllProductsResponse().pipe(
      __map(_r => _r.body as Array<Product>)
    );
  }

  /**
   * @param productId undefined
   */
  ProductGetProductByIdResponse(productId?: number): __Observable<__StrictHttpResponse<Product>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (productId != null) __params = __params.set('productId', productId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Product/GetProductById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Product>;
      })
    );
  }
  /**
   * @param productId undefined
   */
  ProductGetProductById(productId?: number): __Observable<Product> {
    return this.ProductGetProductByIdResponse(productId).pipe(
      __map(_r => _r.body as Product)
    );
  }

  /**
   * @param model undefined
   */
  ProductCreateProductResponse(model: Product): __Observable<__StrictHttpResponse<Product>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Product/CreateProduct`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Product>;
      })
    );
  }
  /**
   * @param model undefined
   */
  ProductCreateProduct(model: Product): __Observable<Product> {
    return this.ProductCreateProductResponse(model).pipe(
      __map(_r => _r.body as Product)
    );
  }

  /**
   * @param model undefined
   */
  ProductUpdateResponse(model: Product): __Observable<__StrictHttpResponse<Product>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Product/UpdateProduct`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Product>;
      })
    );
  }
  /**
   * @param model undefined
   */
  ProductUpdate(model: Product): __Observable<Product> {
    return this.ProductUpdateResponse(model).pipe(
      __map(_r => _r.body as Product)
    );
  }

  /**
   * @param productId undefined
   */
  ProductDeleteProductByIdResponse(productId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (productId != null) __params = __params.set('productId', productId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/Product/DeleteProductById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param productId undefined
   */
  ProductDeleteProductById(productId?: number): __Observable<Blob> {
    return this.ProductDeleteProductByIdResponse(productId).pipe(
      __map(_r => _r.body as Blob)
    );
  }
  ProductGetAllDeletedProductsResponse(): __Observable<__StrictHttpResponse<Array<Product>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Product/GetAllDeletedProducts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Product>>;
      })
    );
  }  ProductGetAllDeletedProducts(): __Observable<Array<Product>> {
    return this.ProductGetAllDeletedProductsResponse().pipe(
      __map(_r => _r.body as Array<Product>)
    );
  }

  /**
   * @param productId undefined
   */
  ProductRestoreDeletedProductByIDResponse(productId?: number): __Observable<__StrictHttpResponse<Product>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (productId != null) __params = __params.set('productId', productId.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Product/RestoreDeletedProductByID`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Product>;
      })
    );
  }
  /**
   * @param productId undefined
   */
  ProductRestoreDeletedProductByID(productId?: number): __Observable<Product> {
    return this.ProductRestoreDeletedProductByIDResponse(productId).pipe(
      __map(_r => _r.body as Product)
    );
  }
}

module ProductService {
}

export { ProductService }
